import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./ProductDetail.css";

/* ✅ SINGLE SOURCE OF TRUTH */
import products from "../../data/products";

import ReviewSlider from "../ReviewSlider";
import FeaturesSection from "../FeaturesSection";
import BlogSection from "../BlogPage";
import OrderPopup from "./OrderPopup";
import SexToysFAQIndia from "../SexToysFAQIndia";

/* ✅ DEFAULT PRODUCT (SAFE FALLBACK) */
const defaultProduct = {
  id: "0",
  name: "Product Not Available",
  image: "/image/no-image.png",
  price: "0",
  mrp: "0",
  description: "Product details will be updated soon.",
  category: "",
};

function ProductDetail() {
  const { state } = useLocation();
  const { id } = useParams();

  /* ✅ STATE > URL > FALLBACK */
  const product =
    state ||
    products.find(
      (item) =>
        String(item.id) === String(id) || item.slug === id
    ) ||
    { ...defaultProduct, id };

  const price = Number(product.price);
  const mrp = Number(product.mrp);

  const [showPopup, setShowPopup] = useState(false);
  const [qty, setQty] = useState(1);
  const [whatsappNumber, setWhatsappNumber] = useState("");

  useEffect(() => {
    const wa = localStorage.getItem("whatsappNumber");
    setWhatsappNumber(wa || "919999999999");
  }, []);

  /* ✅ AUTO SEO URL FIX */
  useEffect(() => {
    if (product.slug && id !== product.slug) {
      window.history.replaceState(
        null,
        "",
        `/product/${product.slug}`
      );
    }
  }, [id, product.slug]);

  // const whatsappMessage = encodeURIComponent(
  //   `Hello, I want to order:\n\nProduct: ${product.name}\nQuantity: ${qty}\nPrice: ₹${price}`
  // );
  const whatsappMessage = encodeURIComponent(
  `Hello, I want to order:\n\nProduct Number: ${product.id}\nQuantity: ${qty}\nPrice: ₹${price}`
);


  const canonicalUrl = `https://www.lushdesire.com/product/${
    product.slug || product.id
  }`;

  return (
    <>
      {/* ✅ SEO META TAGS */}
      <Helmet>
        <title>
          Buy {product.name} in India | Discreet Delivery | LushDesire
        </title>

        <meta
          name="description"
          content={
            product.description
              ? product.description.substring(0, 160)
              : "Buy premium personal wellness products in India with discreet delivery."
          }
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={canonicalUrl} />

        {/* ✅ PRODUCT SCHEMA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "Product",
            name: product.name,
            image: `https://www.lushdesire.com${product.image}`,
            description: product.description,
            brand: {
              "@type": "Brand",
              name: "LushDesire",
            },
            offers: {
              "@type": "Offer",
              priceCurrency: "INR",
              price: price,
              availability: "https://schema.org/InStock",
              url: canonicalUrl,
            },
          })}
        </script>
      </Helmet>

      <div className="product-detail-container" aria-label={product.name}>
        {/* 🔹 H1: Product Name */}
        <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
          {product.name} – Buy Online in India
        </h1>

        <div className="top-section">
          <div className="product-image-box">
            <img
              src={process.env.PUBLIC_URL + product.image}
              alt={`${product.name} personal wellness product`}
              loading="lazy"
              onError={(e) => {
                e.target.src =
                  process.env.PUBLIC_URL + "/image/no-image.png";
              }}
            />
          </div>

          <div className="product-info-box">
            {/* 🔹 H2: Price Section */}
            <h2>Price & Purchase Options</h2>

            <div className="rating">
              ⭐⭐⭐⭐⭐ <span>(100 reviews)</span>
            </div>

            <div className="price">
              {mrp > price && <span className="mrp">Rs. {mrp}</span>}
              <span className="sale">Rs. {price}</span>
            </div>

            {/* 🔹 H3: WhatsApp Order */}
            <h3>
              <a
                href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-btn"
              >
                Order On WhatsApp
              </a>
            </h3>

            {/* 🔹 H4: Quantity Selector */}
            <h4>Choose Quantity</h4>
            <div className="quantity-box">
              <span>Quantity</span>
              <div className="qty-controls">
                <button onClick={() => qty > 1 && setQty(qty - 1)}>-</button>
                <span>{qty}</span>
                <button onClick={() => setQty(qty + 1)}>+</button>
              </div>
            </div>

            {/* 🔹 H4: COD Button */}
            <h4>
              <button className="cod-btn" onClick={() => setShowPopup(true)}>
                Order Now – Cash on Delivery
              </button>
            </h4>

            {/* 🔹 H5: Social Share */}
            <h5>Share this Product</h5>
            <div className="share-box">
              <div className="share-icons">
                <i className="fab fa-facebook-f"></i>
                <i className="fab fa-twitter"></i>
                <i className="fab fa-instagram"></i>
                <i className="fab fa-whatsapp"></i>
                <i className="fab fa-linkedin-in"></i>
              </div>
            </div>

            {/* 🔹 H5: Catalog */}
            <h5>Catalog</h5>
            <div className="catalog">
              <button>
                {product.category === "men"
                  ? "For Men"
                  : product.category === "women"
                  ? "For Women"
                  : "Products"}
              </button>
            </div>
          </div>
        </div>

        {/* 🔹 H2: Product Description Section */}
        <div className="description-section">
          <h2>Product Description</h2>
          <p>{product.description}</p>
        </div>

        {/* 🔹 Supporting Sections */}
        <SexToysFAQIndia />
        <ReviewSlider productId={product.id} />
        <FeaturesSection product={product} />
        <BlogSection />

        {showPopup && (
          <OrderPopup
            product={{ ...product, qty }}
            closePopup={() => setShowPopup(false)}
          />
        )}
      </div>
    </>
  );
}

export default ProductDetail;
